(function () {
    'use strict';

    function getAttributeDisplayValue() {
        return function (value, attributeData) {
            var formattedValue = value;

            if (!attributeData.$type) {
                if (Array.isArray(formattedValue)) {
                    var joinedList = formattedValue.join(", ");
                    return joinedList.length > 0 ? joinedList : "N/A";
                }

                if (typeof(formattedValue) === "boolean") {
                    return formattedValue ? "Yes" : "No";
                }

                return formattedValue;
            }

            switch (attributeData.$type) {
                case ("Ecap.Api.ViewModels.TextSearchFieldViewModel, Ecap.Api"):
                    if (Array.isArray(value)) {
                        var joinedTextValueList = formattedValue.join(", ");
                        formattedValue = joinedTextValueList.length > 0 ? joinedTextValueList : "N/A";
                    }
                    break;
                case ("Ecap.Api.ViewModels.IntegerSearchFieldViewModel, Ecap.Api"):
                case ("Ecap.Api.ViewModels.DecimalSearchFieldViewModel, Ecap.Api"):
                    if (!value) {
                        return "N/A";
                    }

                    var matchingValue = attributeData.Options.find(function(option) {
                        return option.Value = value.toString();
                    });
                    if (matchingValue) {
                        formattedValue = matchingValue.Text;
                    }
                    break;
                case ("Ecap.Api.ViewModels.BooleanSearchFieldViewModel, Ecap.Api"):
                    formattedValue = attributeData.Value ? 'Yes' : 'No';
                    break;
            }

            return formattedValue;
        };
    }

    angular.module('ecap.common').filter('getAttributeDisplayValue', getAttributeDisplayValue);
})();